export default {
    workspaces: {
        que: "Escritorios virtuales (Windows o Linux) en la nube a los que se accede desde cualquier dispositivo, con los datos protegidos en AWS.",
        patron: "lineal",
        nodos: [["Persona + dispositivo", "usuario"], ["Directorio (login)", "clave"], ["WorkSpace", "servidor"]],
        pasos: ["La persona inicia sesión con su usuario del directorio.", "WorkSpaces asigna su escritorio virtual y transmite la pantalla al dispositivo; los archivos nunca salen de AWS."],
        objetos: {
            "WorkSpaces": ["Cada escritorio virtual asignado a una persona.", 2],
            "Directorios": ["Directorio de usuarios que autentica el acceso.", 1],
            "Bundles": ["Combinación de sistema operativo, CPU, memoria y disco del escritorio.", 2],
        },
    },
    appstream: {
        que: "Entrega aplicaciones de escritorio por streaming al navegador, sin instalarlas en el equipo del usuario.",
        patron: "lineal",
        nodos: [["Navegador del usuario", "usuario"], ["Stack AppStream", "engranaje"], ["Flota de instancias", "servidor"]],
        pasos: ["El usuario abre el enlace de la aplicación.", "AppStream le asigna una instancia de la flota con la aplicación instalada y le transmite la imagen y la interacción."],
        objetos: {
            "Flotas": ["Conjunto de instancias que ejecutan las aplicaciones y escalan con la demanda.", 2],
            "Stacks": ["Une la flota con permisos, almacenamiento y políticas de uso.", 1],
            "Imágenes": ["Imagen del sistema con las aplicaciones ya instaladas.", 2],
        },
    },
    connect: {
        que: "Centro de contacto en la nube: recibe llamadas y chats, los enruta a la persona o bot adecuado y registra todo, sin telefonía física.",
        patron: "lineal",
        nodos: [["Cliente (llamada / chat)", "movil"], ["Flujo de contacto", "red"], ["Cola", "cola"], ["Agente", "usuario"]],
        pasos: ["El cliente llama o escribe al número o chat de la empresa.", "El flujo de contacto lo atiende: menú de voz, identificación, bot.", "Se coloca en una cola según la necesidad y el primer agente disponible lo atiende."],
        objetos: {
            "Instancias": ["El centro de contacto completo con sus números, usuarios y configuración.", 1],
            "Colas": ["Lista de espera de contactos por área o habilidad.", 2],
            "Flujos de contacto": ["Guion que decide qué hacer con cada contacto (menús, bots, transferencias).", 1],
        },
    },
    ses: {
        que: "Envío y recepción de correo a gran escala (transaccional y masivo), con medición de entregas, rebotes y quejas.",
        patron: "lineal",
        nodos: [["Tu aplicación", "servidor"], ["Amazon SES", "correo"], ["Bandeja del cliente", "usuario"], ["Eventos (rebote, queja)", "campana"]],
        pasos: ["La aplicación pide enviar un correo desde una identidad verificada.", "SES lo firma (DKIM) y lo entrega al servidor del destinatario.", "Informa por eventos si fue entregado, rebotó, se abrió o se marcó como spam."],
        objetos: {
            "Identidades": ["Dominios o correos verificados desde los que se puede enviar.", 0],
            "Plantillas": ["Mensajes reutilizables con variables de reemplazo.", 1],
            "Configuration Sets": ["Reglas de seguimiento y destino de los eventos de envío.", 3],
            "Supresiones": ["Lista de direcciones a las que no se debe enviar (rebotes o quejas).", 1],
        },
    },
    pinpoint: {
        que: "Campañas de mensajes dirigidos (correo, SMS, push) a segmentos de usuarios, con análisis de resultados.",
        patron: "lineal",
        nodos: [["Segmento de usuarios", "usuario"], ["Campaña Pinpoint", "campana"], ["Canal (correo / SMS / push)", "correo"], ["Análisis", "grafico"]],
        pasos: ["Defines un segmento según el comportamiento de los usuarios.", "La campaña elige el mensaje y el momento.", "Se envía por el canal y se miden las aperturas y conversiones."],
        objetos: {
            "Proyectos": ["Espacio que agrupa los usuarios, campañas y análisis de una app.", 1],
            "Campañas": ["Mensaje programado o disparado por eventos hacia un segmento.", 1],
            "Segmentos": ["Grupos de usuarios definidos por atributos o comportamiento.", 0],
        },
    },
    workmail: {
        que: "Correo y calendario empresarial administrado, compatible con Outlook, con seguridad y cifrado integrados.",
        patron: "lineal",
        nodos: [["Usuario (Outlook / web)", "usuario"], ["WorkMail", "correo"], ["Buzones cifrados", "datos"]],
        pasos: ["El usuario accede con su cliente de correo o desde el navegador.", "WorkMail entrega y guarda los mensajes y el calendario en buzones cifrados con claves de KMS."],
        objetos: {
            "Organizaciones": ["Espacio del dominio de correo de la empresa.", 1],
            "Usuarios": ["Buzones de las personas, con alias y permisos.", 2],
        },
    },
    iotcore: {
        que: "Conecta millones de dispositivos (sensores, máquinas) de forma segura a AWS, recibe sus datos y puede enviarles órdenes.",
        patron: "lineal",
        nodos: [["Dispositivo (Thing)", "movil"], ["Broker MQTT", "cola"], ["Regla IoT", "engranaje"], ["Servicios AWS", "nube"]],
        pasos: ["El dispositivo se conecta con su certificado y publica un mensaje MQTT.", "El broker lo recibe tras validar la política de permisos.", "Una regla lo filtra y lo envía a Lambda, S3, DynamoDB u otros servicios."],
        objetos: {
            "Things": ["Representación en la nube de cada dispositivo físico.", 0],
            "Certificados": ["Identidad X.509 con la que el dispositivo se autentica.", 0],
            "Políticas": ["Qué temas puede publicar o leer cada dispositivo.", 1],
            "Reglas": ["Consultas que reenvían los mensajes a otros servicios.", 2],
        },
    },
    greengrass: {
        que: "Ejecuta lógica en el dispositivo o en una pasarela local, aun sin conexión: procesa datos en el borde y sincroniza con AWS cuando hay red.",
        patron: "lineal",
        nodos: [["Sensores", "movil"], ["Dispositivo core Greengrass", "servidor"], ["Componentes locales", "engranaje"], ["AWS IoT", "nube"]],
        pasos: ["Los sensores envían datos al dispositivo local.", "Los componentes (funciones, modelos) procesan y deciden en el momento.", "Cuando hay conexión, se sincronizan los resultados y se reciben despliegues nuevos."],
        objetos: {
            "Dispositivos core": ["El equipo que ejecuta el software Greengrass en el borde.", 1],
            "Componentes": ["Módulos de software que se ejecutan en el dispositivo.", 2],
            "Despliegues": ["Envío de componentes y configuración a un grupo de dispositivos.", 3],
        },
    },
    mediaconvert: {
        que: "Convierte archivos de video a los formatos y resoluciones necesarios para cualquier pantalla, bajo demanda y a escala.",
        patron: "lineal",
        nodos: [["Video original (S3)", "video"], ["MediaConvert Job", "engranaje"], ["Salidas (HLS, MP4)", "video"]],
        pasos: ["Subes el video fuente a S3 y creas un job con el preset deseado.", "MediaConvert transcodifica, genera múltiples calidades y los deja en S3 listos para CloudFront."],
        objetos: {
            "Jobs": ["Cada conversión pedida con su origen y sus salidas.", 1],
            "Colas": ["Controlan prioridad y capacidad reservada para los jobs.", 1],
            "Presets": ["Configuración reutilizable de códec, resolución y calidad.", 1],
        },
    },
    medialive: {
        que: "Procesa video en vivo: recibe la señal, la codifica en varias calidades y la entrega para transmitir a grandes audiencias.",
        patron: "lineal",
        nodos: [["Cámara / encoder", "video"], ["Input", "cola"], ["Canal MediaLive", "engranaje"], ["Salida a CDN", "globo"]],
        pasos: ["La señal en vivo llega a un input.", "El canal la codifica en varias calidades (bitrate adaptativo).", "Se entrega a MediaPackage o CloudFront para distribuirla a los espectadores."],
        objetos: {
            "Canales": ["Proceso que codifica la señal y la entrega.", 2],
            "Inputs": ["Puntos de entrada de la señal (RTMP, SRT, HLS).", 1],
        },
    },
    ivs: {
        que: "Transmisión de video en vivo de baja latencia lista para usar: obtienes un canal y reproductor, sin armar la infraestructura.",
        patron: "lineal",
        nodos: [["Emisor (OBS, app)", "video"], ["Canal IVS", "nube"], ["Espectadores", "usuario"]],
        pasos: ["El emisor transmite al canal con su Stream Key.", "IVS transcodifica y entrega el video con latencia de pocos segundos a los espectadores en el reproductor."],
        objetos: {
            "Canales": ["Punto de ingesta y reproducción de una transmisión.", 1],
            "Stream Keys": ["Clave secreta que autoriza a emitir a un canal.", 0],
        },
    },
};
